var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('svg-icon',{attrs:{"class-name":"reload-icon","icon-class":"reload"},on:{"click":_vm.click}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }